<template>
  <PageWrapper :page-data="pageData"
               :brand="brandFromStore">
    <template #header-logo>
      <HeaderLogo />
    </template>
    <template #header-user-navi>
      <HeaderUserNavi />
    </template>
    <template #header-search>
      <HeaderSearch />
    </template>
    <template #footer>
      <PageFooter :brand="brandFromStore"
                  :footer-data="pageData.footer" />
    </template>
  </PageWrapper>
</template>

<script>
import { mapState } from 'pinia'

import { usePageStore } from '../../stores/page'
// these components will be injected into the app via slots
import PageWrapper from '../../components/PageWrapper.vue'
import HeaderUserNavi from '../../components/shared/HeaderUserNavi.vue'
import { useDefaultAppInit, defaultAppInitProps } from '../../composables/use-default-app-init'
import PageFooter from './theme/Footer.vue'
import HeaderLogo from './theme/HeaderLogo.vue'
import HeaderSearch from './theme/HeaderSearch.vue'

export default {
  components: {
    HeaderLogo,
    HeaderSearch,
    PageFooter,
    HeaderUserNavi,
    PageWrapper
  },
  props: defaultAppInitProps,
  setup (props) {
    useDefaultAppInit(props)
  },
  computed: {
    ...mapState(usePageStore, ['pageData', 'brandFromStore'])
  }
}
</script>
